import { PagenotfoundComponent } from "./pagenotfound/pagenotfound.component";
import { ServicesComponent } from "./services/services.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { DashboardComponent } from "./dashboard/dashboard.component";
import { OrdersComponent } from "./listtransactions/orders.component";
import { LocationComponent } from "./location/location.component";
import { UsersComponent } from "./users/users.component";
import { IncidentComponent } from "./incident/incident.component";
import { CustomersComponent } from "./customers/customers.component";
import { DetailsComponent } from "./detailsCutstomers/details.component";
import { DetailsTransactionsComponent } from "./details-transactions/details-transactions.component";
import { ListQrpayCodeComponent } from "./list-qrpay-code/list-qrpay-code.component";
import { DetailQrpayCodeComponent } from "./detail-qrpay-code/detail-qrpay-code.component";
import { CreateOrderComponent } from "./create-order/create-order.component";
import { LoginComponent } from "../account/auth/login/login.component";
import { DetailCreateOrderComponent } from "./detail-create-order/detail-create-order.component";
import { AuthRoleGuard } from "../core/guards/authRole.guard";
// import { ListWorkspaceComponent } from './list-workspace/list-workspace.component';
import { AccountComponent } from "./account/account.component";
import { ListMemberComponent } from "./list-member/list-member.component";
import { ListWorkspaceComponent } from "./list-workspace/list-workspace.component";
import { DetailWorkspaceComponent } from "./detail-workspace/detail-workspace.component";
import { SearchTransactionsComponent } from "./search-transactions/search-transactions.component";
import { EditProfileComponent } from "./edit-profile/edit-profile.component";
import { DeviceStockComponent } from "./device-stock/device-stock.component";
import { OrdersManagerComponent } from "./orders-manager/orders-manager.component";
import { DeviceQrComponent } from "./device-qr/device-qr.component";
import { DetalOrderComponent } from "./detal-order/detal-order.component";
import { DashboardNewComponent } from "./dashboard-new/dashboard-new.component";
import { GHNPendingComponent } from "./ghn-pending/ghn-pending.component";
import { ManagerQrComponent } from "./manager-qr/manager-qr.component";
import { BranchManagerComponent } from "./branch-manager/branch-manager.component";
import { BranchHistoryComponent } from "./branch-history/branch-history.component";
import { DetailHistoryComponent } from "./detail-history/detail-history.component";
import { MBDashboardComponent } from "./mb-dashboard/mb-dashboard.component";
import { RMManagementComponent } from "./rm-management/rm-management.component";
import { ReferralCodeComponent } from "./referral-code/referral-code.component";
import { DeviceComponent } from "./device/device.component";
import { ReturnManagerComponent } from "./return-manager/return-manager.component";
import { DetailGhnPendingComponent } from "./detail-ghn-pending/detail-ghn-pending.component";
import { ReturnConfirmComponent } from "./return-confirm/return-confirm.component";
import { VtpPendingComponent } from "./vtp-pending/vtp-pending.component";
import { SearchOrderComponent } from "./search-order/search-order.component";
import { DetailSearchOrderComponent } from "./detail-search-order/detail-search-order.component";
import { ExpiredpageComponent } from "./expiredpage/expiredpage.component";
import { VccPendingComponent } from "./vcc-pending/vcc-pending.component";
import { VccDoneComponent } from "./vcc-done/vcc-done.component";
import { BranchOrdersComponent } from "../branch-orders/branch-orders.component";
import { ManagerBranchOrderComponent } from "../manager-branch-order/manager-branch-order.component";
import { AnonQrComponent } from "./anon-qr/anon-qr.component";
import { RenewManagementComponent } from "./renew-management/renew-management.component";
import { RenewDetailComponent } from "./renew-detail/renew-detail.component";
import { AffiliateOrderComponent } from "./affiliate-order/affiliate-order.component";
import { ZNSManagerComponent } from "./zns-manager/zns-manager.component";
import { ZnsFailedManagerComponent } from "./zns-failed-manager/zns-failed-manager.component";
import { ManagerInvoiceComponent } from "./manager-invoice/manager-invoice.component";
import { DetailInvoiceComponent } from "./detail-invoice/detail-invoice.component";
import { WaitingManagementComponent } from "./waiting-management/waiting-management.component";
import { IssuanceManagementComponent } from "./issuance-management/issuance-management.component";
import { FailedEmailListComponent } from "./failed-email-list/failed-email-list.component";
import { AccountRegistrationManagementComponent } from "./account-registration-management/account-registration-management.component";
import { AccountGrantedComponent } from "./account-granted/account-granted.component";
import { AbortRequestComponent } from "./abort-request/abort-request.component";
import { ManagerorderTendooComponent } from "./managerorder-tendoo/managerorder-tendoo.component";
import { ReplacementInvoiceComponent } from "./replacement-invoice/replacement-invoice.component";
import { ReportLogsComponent } from "./report-logs/report-logs.component";
import { VoucherManagerComponent } from "./voucher-manager/voucher-manager.component";
import { VoucherOrdersComponent } from "./voucher-orders/voucher-orders.component";
import { QrGenerateComponent } from "./qr-generate/qr-generate.component";
import { MenuqrVtpPendingComponent } from "./menuqr-vtp-pending/menuqr-vtp-pending.component";
import { PartnerOrdersComponent } from "./partner-orders/partner-orders.component";
import { PartnerManagerComponent } from "./partner-manager/partner-manager.component";
import { DetailPartnerComponent } from "./detail-partner/detail-partner.component";
import { ConfirmPartnerComponent } from "./confirm-partner/confirm-partner.component";
import { ReturnPartnerComponent } from "./return-partner/return-partner.component";
import { InvoiceManagerPartnerComponent } from "./invoice-manager-partner/invoice-manager-partner.component";
import { ZnsExtendManagerComponent } from "./zns-extend-manager/zns-extend-manager.component";
import { BusinessGiftOrdersComponent } from "./business-gift-orders/business-gift-orders.component";
import { SystemConfigComponent } from "./system-config/system-config.component";
import { GenQrBassComponent } from "../gen-qr-bass/gen-qr-bass.component";

const routes: Routes = [
  // {
  //     path: '',
  //     redirectTo:'login',
  //     pathMatch: 'full'
  // },
  // { path: '', component: LoginComponent},
  {
    path: "",
    component: DashboardNewComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "operation", "switchboard"],
    },
  },
  {
    path: "search-orders",
    component: SearchOrderComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "switchboard"],
    },
  },
  {
    path: "search-orders/detail-orders/:id",
    component: DetailSearchOrderComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "switchboard"],
    },
  },
  {
    path: "return-manager",
    component: ReturnManagerComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "operation", "customer service", "delivery"],
    },
  },
  {
    path: "return-manager-partner",
    component: ReturnPartnerComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "operation", "customer service", "delivery"],
    },
  },
  {
    path: "expired-page",
    component: ExpiredpageComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "delivery"],
    },
  },
  {
    path: "vcc-done",
    component: VccDoneComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "delivery"],
    },
  },
  {
    path: "vcc-pending",
    component: VccPendingComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "delivery"],
    },
  },
  {
    path: "branch-orders",
    component: BranchOrdersComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "partner_operation"],
    },
  },
  {
    path: "manager-branch-orders",
    component: ManagerBranchOrderComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: [
        "admin",
        "partner_operation",
        "branch_operation",
        "delivery",
      ],
    },
  },
  {
    path: "business-gift-orders",
    component: BusinessGiftOrdersComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: [
        "partner_operation",
        "admin",
        "customer service",
        "switchboard",
      ],
    },
  },
  {
    path: "vcc-Pending/detail-pending-vcc/:id",
    component: DetailGhnPendingComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "delivery", "operation", "customer service"],
    },
  },
  {
    path: "return-manager/detail-orders/:id",
    component: DetalOrderComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "customer service", "delivery", "operation"],
    },
  },
  {
    path: "return-confirm",
    component: ReturnConfirmComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "operation", "customer service", "delivery"],
    },
  },
  {
    path: "return-confirm-partner",
    component: ConfirmPartnerComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "oper   ation", "customer service", "delivery"],
    },
  },
  {
    path: "return-confirm/detail-orders/:id",
    component: DetalOrderComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "customer service", "delivery", "operation"],
    },
  },
  {
    path: "edit-profile",
    component: EditProfileComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: [
        "admin",
        "branch_operation",
        "customer service",
        "delivery",
        "iris_operation",
        "iris_partner",
        "operation",
        "partner_operation",
        "switchboard",
        "viettel_invoice",
      ],
    },
  },
  {
    path: "person",
    component: AccountComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["user"],
    },
  },

  //devices
  {
    path: "device-stock",
    component: DeviceStockComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["customer service", "admin", "delivery"],
    },
  },
  {
    path: "orders-manager",
    component: OrdersManagerComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "customer service", "operation", "delivery"],
    },
  },
  {
    path: "partner-orders",
    component: PartnerOrdersComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "customer service", "operation", "delivery"],
    },
  },
  {
    path: "partner-manager",
    component: PartnerManagerComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin"],
    },
  },
  {
    path: "about-request",
    component: AbortRequestComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "customer service", "operation", "delivery"],
    },
  },
  {
    path: "waiting-payment",
    component: WaitingManagementComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "customer service", "operation", "delivery"],
    },
  },
  {
    path: "GHN-Pending",
    component: GHNPendingComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "delivery", "operation", "customer service"],
    },
  },
  {
    path: "VTP-Tendoo",
    component: ManagerorderTendooComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "delivery", "operation", "customer service"],
    },
  },
  {
    path: "GHN-Pending/detail-pending-ghn/:id",
    component: DetailGhnPendingComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "delivery", "opreation", "customer service"],
    },
  },
  {
    path: "VTP-Pending/detail-pending-vtp/:id",
    component: DetailGhnPendingComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "delivery", "opreation", "customer service"],
    },
  },
  {
    path: "VTP-Pending",
    component: VtpPendingComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "delivery", "operation", "customer service"],
    },
  },
  {
    path: "Partner-VTPPending",
    component: MenuqrVtpPendingComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "delivery", "operation", "customer service"],
    },
  },
  {
    path: "orders-manager/detail-orders/:id",
    component: DetalOrderComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "customer service", "delivery"],
    },
  },
  {
    path: "partner-orders/detail-partner/:id",
    component: DetailPartnerComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "customer service", "delivery"],
    },
  },
  {
    path: "invoice-manager/detail-orders/:id",
    component: DetailInvoiceComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "customer service", "delivery"],
    },
  },
  {
    path: "users",
    component: UsersComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin"],
    },
  },
  // { path: 'booking', component: BookingComponent },
  // { path: 'location', component: LocationComponent, canActivate: [AuthRoleGuard], data: {
  //         accessRole: ['admin', 'user']
  //     } },
  // { path: 'incident', component: IncidentComponent, canActivate: [AuthRoleGuard], data: {
  //         accessRole: ['admin', 'user']
  //     } },
  {
    path: "users/details/:id",
    component: DetailsComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "user"],
    },
  },

  //transactions
  {
    path: "transactions/details-transactions/:id",
    component: DetailsTransactionsComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "user"],
    },
  },
  // { path: '404', component: PagenotfoundComponent, canActivate: [AuthRoleGuard], data: {
  //     accessRole: ['admin','user']
  // } },
  {
    path: "transactions-qr",
    component: ManagerQrComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "operation"],
    },
  },
  {
    path: "search-transactions",
    component: SearchTransactionsComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["user"],
    },
  },
  //qr-pay
  {
    path: "qrpay-code",
    component: ListQrpayCodeComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "user"],
    },
  },
  {
    path: "qrpay-code/:id",
    component: DetailQrpayCodeComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "user"],
    },
  },
  {
    path: "detail-qrpay-code",
    component: DetailQrpayCodeComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["user"],
    },
  },

  //create-order
  {
    path: "create-order",
    component: CreateOrderComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["user"],
    },
  },
  {
    path: "detail-create-order",
    component: DetailCreateOrderComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["user"],
    },
  },

  //member
  {
    path: "member",
    component: ListMemberComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "user"],
    },
  },
  {
    path: "device-qr",
    component: DeviceQrComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "customer service"],
    },
  },

  //workspace
  {
    path: "workspaces",
    component: ListWorkspaceComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "user"],
    },
  },
  {
    path: "workspaces/detail-workspace/:id",
    component: DetailWorkspaceComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "user"],
    },
  },
  {
    path: "MB-dashboard",
    component: MBDashboardComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: [
        "admin",
        "partner_operation",
        "branch_operation",
        "iris_operation",
        "iris_partner",
      ],
    },
  },
  {
    path: "branch",
    component: BranchManagerComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: [
        "admin",
        "partner_operation",
        "branch_operation",
        "iris_operation",
        "iris_partner",
      ],
    },
  },
  {
    path: "branch/detail-branch/:id",
    component: BranchHistoryComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: [
        "admin",
        "partner_operation",
        "branch_operation",
        "iris_operation",
        "iris_partner",
      ],
    },
  },
  {
    path: "branch/detail-history/:id",
    component: DetailHistoryComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: [
        "admin",
        "partner_operation",
        "branch_operation",
        "iris_operation",
        "iris_partner",
      ],
    },
  },
  {
    path: "rm-management",
    component: RMManagementComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: [
        "admin",
        "partner_operation",
        "branch_operation",
        "iris_operation",
        "iris_partner",
      ],
    },
  },
  {
    path: "referral-code",
    component: ReferralCodeComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: [
        "admin",
        "partner_operation",
        "branch_operation",
        "iris_operation",
        "iris_partner",
      ],
    },
  },
  {
    path: "device-agency",
    component: DeviceComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: [
        "admin",
        "partner_operation",
        "branch_operation",
        "iris_operation",
        "iris_partner",
      ],
    },
  },
  {
    path: "qr-generate",
    component: QrGenerateComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: [
        "admin",
        "partner_operation",
        "branch_operation",
        "iris_operation",
        "iris_partner",
      ],
    },
  },
  {
    path: "anon-qr",
    component: AnonQrComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "customer service"],
    },
  },
  {
    path: "renew-package",
    component: RenewManagementComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "customer service", "operation"],
    },
  },
  {
    path: "renew-package/detail/:id",
    component: RenewDetailComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "customer service", "operation"],
    },
  },
  //moi
  //  {
  //     path: 'waiting-payment', component: RenewManagementComponent, canActivate: [AuthRoleGuard], data: {
  //         accessRole: ['admin']
  //     }
  // },
  {
    path: "affiliate-order",
    component: AffiliateOrderComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "customer service"],
    },
  },
  {
    path: "affiliate-order/detail-orders/:id",
    component: DetailGhnPendingComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "customer service", "delivery"],
    },
  },
  {
    path: "zns-manager",
    component: ZNSManagerComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin"],
    },
  },
  {
    path: "zns-failed-manager",
    component: ZnsFailedManagerComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin"],
    },
  },
  {
    path: "zns-extend-manager",
    component: ZnsExtendManagerComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "customer service", "delivery", "switchboard"],
    },
  },
  {
    path: "invoice-manager",
    component: ManagerInvoiceComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "operation"],
    },
  },
  {
    path: "invoice-manager-partner",
    component: InvoiceManagerPartnerComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "operation"],
    },
  },
  {
    path: "invoice-replacementnvoice-manager",
    component: ReplacementInvoiceComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "operation"],
    },
  },
  {
    path: "issuance-management",
    component: IssuanceManagementComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "operation"],
    },
  },
  {
    path: "failed-email-list",
    component: FailedEmailListComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "operation"],
    },
  },
  {
    path: "account-pending",
    component: AccountRegistrationManagementComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: [
        "admin",
        "viettel_invoice",
        "partner_operation",
        "customer service",
      ],
    },
  },
  {
    path: "account-granted",
    component: AccountGrantedComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin", "viettel_invoice", "customer service"],
    },
  },
  {
    path: "report-logs",
    component: ReportLogsComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin"],
    },
  },
  {
    path: "voucher",
    component: VoucherManagerComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin"],
    },
  },
  {
    path: "voucher-orders",
    component: VoucherOrdersComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin"],
    },
  },
  {
    path: "system-config",
    component: SystemConfigComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin"],
    },
  },
    {
    path: "genqr-bass",
    component: GenQrBassComponent,
    canActivate: [AuthRoleGuard],
    data: {
      accessRole: ["admin"],
    },
  },
  // { path: 'kanban-board', component: KanbanComponent },
  // { path: 'settings', component: SettingsComponent },x
  // { path: 'ecommerce', loadChildren: () => import('./ecommerce/ecommerce.module').then(m => m.EcommerceModule) },
  // { path: 'email', loadChildren: () => import('./email/email.module').then(m => m.EmailModule) },
  // { path: 'pages', loadChildren: () => import('./utility/utility.module').then(m => m.UtilityModule) },
  // { path: 'ui', loadChildren: () => import('./ui/ui.module').then(m => m.UIModule) },
  // { path: 'icons', loadChildren: () => import('./icons/icons.module').then(m => m.IconsModule) },
  // { path: 'charts', loadChildren: () => import('./chart/chart.module').then(m => m.ChartModule) },
  // { path: 'form', loadChildren: () => import('./form/form.module').then(m => m.FormModule) },
  // { path: 'tables', loadChildren: () => import('./tables/tables.module').then(m => m.TablesModule) },
  // { path: 'maps', loadChildren: () => import('./maps/maps.module').then(m => m.MapsModule) },
  // { path: 'report', loadChildren: () => import('./report/report.module').then(m => m.ReportModule) },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
